import { useState } from "react";
import ScrollContainer from "react-indiana-drag-scroll";

import FullFilter from "~/components/ui/fullFilter";
import { CapacityEnum } from "~/types/event/eventEnums.type";
import { FullFilterType } from "~/types/filter/filter.types";
import { PrivateLocationType } from "~/types/location/location.types";
import { LocationEnum } from "~/types/location/locationEnums.types";
import { TagType } from "~/types/tag/tag.types";
import { compareCapacity, numberToCapacity } from "~/utils/constants/capacity";

import PrivateLocation from "../privateLocation";
import styles from "./index.module.scss";

interface Props {
  tags: TagType[];
  privateLocations: PrivateLocationType[];
}

const PrivateEventsDisplay = ({ privateLocations, tags }: Props) => {
  const [fullFilter, setFullFilter] = useState<FullFilterType>({
    locations: [],
    capacities: [],
    tags: [],
  });

  const handleResetFilter = () => {
    setFullFilter({ locations: [], capacities: [], tags: [] });
  };

  const handleSetLocationFilter = (filterName: LocationEnum) => {
    setFullFilter((prev) => {
      const locations = prev.locations.includes(filterName)
        ? prev.locations.filter((locations) => locations !== filterName)
        : [...prev.locations, filterName];
      return { ...prev, locations };
    });
  };

  const handleSetCapacityFilter = (filterName: CapacityEnum) => {
    setFullFilter((prev) => {
      return { ...prev, capacities: [filterName] };
    });
  };

  const handleSetTagFilter = (filterName: TagType) => {
    setFullFilter((prev) => {
      const tags = prev.tags.includes(filterName)
        ? prev.tags.filter((tag) => tag !== filterName)
        : [...prev.tags, filterName];
      return { ...prev, tags };
    });
  };

  const filteredPrivateLocations = privateLocations.filter((location) => {
    return (
      (fullFilter.capacities.length === 0 ||
        compareCapacity(
          fullFilter.capacities[0],
          numberToCapacity(location.capacityNumber)
        )) &&
      (fullFilter.locations.length === 0 ||
        fullFilter.locations.includes(location.location)) &&
      (fullFilter.tags.length === 0 ||
        fullFilter.tags
          .map(({ id }) => id)
          .some((id) => location.tags.map(({ id }) => id).includes(id)))
    );
  });

  return (
    <>
      <ScrollContainer className={styles.filterScroll}>
        <FullFilter
          tags={tags}
          fullFilter={fullFilter}
          useCapacityFilter={true}
          handleResetFilter={handleResetFilter}
          handleSetLocationFilter={handleSetLocationFilter}
          handleSetCapacityFilter={handleSetCapacityFilter}
          handleSetTagFilter={handleSetTagFilter}
        />
      </ScrollContainer>

      <div className={styles.eventsGrid}>
        {filteredPrivateLocations.map((privateLocation) => {
          return (
            <PrivateLocation
              key={privateLocation.id}
              privateLocation={privateLocation}
            />
          );
        })}
      </div>
    </>
  );
};

export default PrivateEventsDisplay;
